import * as yup from 'yup';
import { get } from "lodash";

const validators = (__) => () => {
    return (
        yup.object({
            priceFuel: yup.string().required(__(`form.priceFuel.error`)),
            fuelType: yup.string().required(__(`form.fuelType.error`)),
            startDate: yup.string().required(__(`form.startDate.error`)),
            endDate: yup.string().required(__(`form.endDate.error`)),
            
        })
    )
}

export default validators
